import { render, staticRenderFns } from "./AdjustmentDataSostam.vue?vue&type=template&id=fb1c4392"
import script from "./AdjustmentDataSostam.vue?vue&type=script&lang=js"
export * from "./AdjustmentDataSostam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports